import React from 'react';
import { useTranslation } from 'react-i18next';
import AlignHorizontalLeftRoundedIcon from '@mui/icons-material/AlignHorizontalLeftRounded';
import AlignHorizontalCenterRoundedIcon from '@mui/icons-material/AlignHorizontalCenterRounded';
import AlignHorizontalRightRoundedIcon from '@mui/icons-material/AlignHorizontalRightRounded';
import AlignVerticalTopRoundedIcon from '@mui/icons-material/AlignVerticalTopRounded';
import AlignVerticalCenterRoundedIcon from '@mui/icons-material/AlignVerticalCenterRounded';
import AlignVerticalBottomRoundedIcon from '@mui/icons-material/AlignVerticalBottomRounded';
import CommonTypography from '@src/new-components/Typography';
import { CAPTION_POSITION_RANGE } from '@vbee-holding/aivoice-shared-lib';
import ConfigRow from './controls/ConfigRow';
import ChipTabs from './controls/ChipTabs';
import NumberInput from './controls/NumberInput';

// Ba chip chỉ là ba mốc 0 / 50 / 100 của chính ô số bên cạnh.
const CHIP_TABS_WIDTH = 104;
const NUMBER_WIDTH = 100;

const ROWS = [
  {
    axis: 'x',
    label: 'X',
    options: [
      { value: 0, icon: AlignHorizontalLeftRoundedIcon },
      { value: 50, icon: AlignHorizontalCenterRoundedIcon },
      { value: 100, icon: AlignHorizontalRightRoundedIcon },
    ],
  },
  {
    axis: 'y',
    label: 'Y',
    options: [
      { value: 0, icon: AlignVerticalTopRoundedIcon },
      { value: 50, icon: AlignVerticalCenterRoundedIcon },
      { value: 100, icon: AlignVerticalBottomRoundedIcon },
    ],
  },
];

const PositionGroup = ({ position, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="config-group">
      <CommonTypography className="config-group-label" variant="body-14-medium">
        {t('captionPosition')}
      </CommonTypography>
      <div className="config-group-rows">
        {ROWS.map(({ axis, label, options }) => (
          <ConfigRow key={axis} label={label}>
            <ChipTabs
              width={CHIP_TABS_WIDTH}
              options={options}
              value={position[axis]}
              onChange={(value) => onChange({ [axis]: value })}
            />
            <NumberInput
              width={NUMBER_WIDTH}
              value={position[axis]}
              range={CAPTION_POSITION_RANGE}
              suffix="%"
              onChange={(value) => onChange({ [axis]: value })}
            />
          </ConfigRow>
        ))}
      </div>
    </div>
  );
};

export default PositionGroup;
